import ChartComponent from "./ChartComponent";

// Utility function to process data
export const processData = (data, metricKey, label) => {
    // Sort data by date
    if (!data || data.length === 0) {
        console.warn(`No data provided for ${label}`);
        return {
            labels: [],
            datasets: [{
                label: label,
                data: [],
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            }]
        };
    }

    const sortedData = [...data].sort(
        (a, b) =>
            new Date(a.pageViews.date).getTime() - new Date(b.pageViews.date).getTime()
    );
    // Extract labels and data points using UTC dates
    const labels = sortedData.map((item) => {
        const dateParts = item.pageViews.date.split('-');
        const year = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Months are zero-based
        const day = parseInt(dateParts[2], 10);
        const dateObj = new Date(Date.UTC(year, month, day));
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC',
        };
        return dateObj.toLocaleDateString(undefined, options);
    });
    const metricData = sortedData.map((item) => {
        let value;
        if (metricKey.includes('.')) {
            // For nested keys like ‘productClicks.productClicks’
            const keys = metricKey.split('.');
            value = item[keys[0]][keys[1]];
        } else {
            value = item.pageViews[metricKey];
        }
        value = Number(value);
        return isNaN(value) ? 0 : value;
    });
    return {
        labels: labels,
        datasets: [
            {
                label: label,
                data: metricData,
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };
};


export const processData2 = (data, metricKey, label) => {
    // Sort data by date
    // Sort data by date
    const sortedData = [...data].sort(
        (a, b) =>
            new Date(a.pageViews.date).getTime() - new Date(b.pageViews.date).getTime()
    );
    // Extract labels and data points using UTC dates
    const labels = sortedData.map((item) => {
        const dateParts = item.pageViews.date.split('-');
        const year = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Months are zero-based
        const day = parseInt(dateParts[2], 10);
        const dateObj = new Date(Date.UTC(year, month, day));
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC',
        };
        return dateObj.toLocaleDateString(undefined, options);
    });
    const metricData = sortedData.map((item) => {
        let value;
        if (metricKey.includes('.')) {
            // For nested keys like ‘productClicks.productClicks’
            const keys = metricKey.split('.');
            value = item[keys[0]] && item[keys[0]][keys[1]] ? item[keys[0]][keys[1]] : 0;
        } else {
            value = item.pageViews && item.pageViews[metricKey] ? item.pageViews[metricKey] : 0;
        }
        value = Number(value);
        return isNaN(value) ? 0 : value;
    });
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: label,
                data: metricData,
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };

    return chartData;
};

// Chart for Screen Page Views
export const NewUsersChart = (chartData) => {

    if (!chartData) {
        console.error('chartData is undefined');
        return <div>No data available for Screen Page Views</div>;
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `New Users`,
                font: {
                    size: 18,
                    weight: 'bold',
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Views',
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Date',
                },
            },
        },
    };
    return (
        <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ChartComponent type="line" data={chartData.chartData} options={options} />
        </div>
    );
};
// Chart for Average Session Duration
export const AverageSessionDurationChart = (chartData) => {
    if (!chartData) {
        return <div>No data available for Average Session Duration</div>;
    }
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `Average Session Duration`,
                font: {
                    size: 18,
                    weight: 'bold',
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Duration (Seconds)',
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Date',
                },
            },
        },
    };
    return (
        <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ChartComponent type="line" data={chartData.chartData} options={options} />
        </div>
    );
};
// Chart for Product Clicks
export const ProductClicksChart = (chartData) => {
    if (!chartData) {
        return <div>No data available for Product Clicks</div>;
    }
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Product Clicks',
                font: {
                    size: 18,
                    weight: 'bold',
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Clicks',
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Date',
                },
            },
        },
    };
    return (
        <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ChartComponent type="line" data={chartData.chartData} options={options} />
        </div>
    );
};

export const BounceRateChart = (chartData) => {
    if (!chartData) {
        return <div>No data available for Average Session Duration</div>;
    }
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `Bounce Rate`,
                font: {
                    size: 18,
                    weight: 'bold',
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Percentage',
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Date',
                },
            },
        },
    };
    return (
        <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ChartComponent type="line" data={chartData.chartData} options={options} />
        </div>
    );
};







